import { render, staticRenderFns } from "./PromotionAudienceTypeField.vue?vue&type=template&id=40104b28"
import script from "./PromotionAudienceTypeField.vue?vue&type=script&lang=js"
export * from "./PromotionAudienceTypeField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports